module.exports = __webpack_public_path__ + "img/材料力学1_6_1.7a250ba9.jpg";